"use strict";
exports.__esModule = true;
exports.isAlreadyExistingWalletError = exports.isNonExistingWalletError = exports.isNonExistingAccountError = exports.remapLibcoreErrors = exports.setRemapLibcoreErrorsImplementation = void 0;
var impl = function (e) {
    return e && e instanceof Error ? e : new Error(String(e));
};
function setRemapLibcoreErrorsImplementation(remap) {
    impl = remap;
}
exports.setRemapLibcoreErrorsImplementation = setRemapLibcoreErrorsImplementation;
function remapLibcoreErrors(error) {
    return impl(error);
}
exports.remapLibcoreErrors = remapLibcoreErrors;
function isNonExistingAccountError(error) {
    return error.message.includes("doesn't exist");
}
exports.isNonExistingAccountError = isNonExistingAccountError;
function isNonExistingWalletError(error) {
    return error.message.includes("doesn't exist");
}
exports.isNonExistingWalletError = isNonExistingWalletError;
function isAlreadyExistingWalletError(error) {
    return error.message.includes("already exists");
}
exports.isAlreadyExistingWalletError = isAlreadyExistingWalletError;
//# sourceMappingURL=errors.js.map